import { MenuOptionType } from "@dexteel/mesf-core";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import { CommodityType } from "../../../models/CommodityType";

type Props = {
  setCommodityType: (commodityType: CommodityType) => void;
  setShowModal: (modal: "new" | "edit" | "delete" | "") => void;
  handleNewCommodityType: () => void;
};

export const useCommodityTypeOptionsFunctions = ({
  setCommodityType,
  setShowModal,
  handleNewCommodityType,
}: Props) => {
  const getMenuOptions = (data: CommodityType) => {
    let options: MenuOptionType[] = [];
    options = options.concat([
      {
        name: "New Commodity Type",
        key: "new_commodity_type",
        onClick: () => {
          handleNewCommodityType();
        },
        icon: <PlaylistAddIcon />,
      },
    ]);
    if (data && !data.IsSystemType) {
      options = options.concat([
        {
          name: "Edit Commodity Type",
          key: "edit_commodity_type",
          onClick: () => {
            setCommodityType(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Commodity Type",
          key: "delete_commodity_type",
          onClick: () => {
            setCommodityType(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
